// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

// shopping cart
frappe.provide("erpnext.shopping_cart");
var shopping_cart = erpnext.shopping_cart;

var getParams = function (url) {
	var params = [];
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

frappe.ready(function() {
	var full_name = frappe.session && frappe.session.user_fullname;
	// update user
	if(full_name) {
		$('.navbar li[data-label="User"] a')
			.html('<i class="fa fa-fixed-width fa fa-user"></i> ' + full_name);
	}
	// set coupon code and sales partner code

	var url_args = getParams(window.location.href);

	var referral_coupon_code = url_args['cc'];
	var referral_sales_partner = url_args['sp'];

	var d = new Date();
	// expires within 30 minutes
	d.setTime(d.getTime() + (0.02 * 24 * 60 * 60 * 1000));
	var expires = "expires="+d.toUTCString();
	if (referral_coupon_code) {
		document.cookie = "referral_coupon_code=" + referral_coupon_code + ";" + expires + ";path=/";
	}
	if (referral_sales_partner) {
		document.cookie = "referral_sales_partner=" + referral_sales_partner + ";" + expires + ";path=/";
	}
	referral_coupon_code=frappe.get_cookie("referral_coupon_code");
	referral_sales_partner=frappe.get_cookie("referral_sales_partner");

	if (referral_coupon_code && $(".tot_quotation_discount").val()==undefined ) {
		$(".txtcoupon").val(referral_coupon_code);
	}
	if (referral_sales_partner) {
		$(".txtreferral_sales_partner").val(referral_sales_partner);
	}

	// update login
	shopping_cart.get_cart_settings(() => {
		shopping_cart.show_shoppingcart_dropdown();
		shopping_cart.set_cart_count();
		shopping_cart.bind_dropdown_cart_buttons();
		shopping_cart.show_cart_navbar();
		if(shopping_cart.shopping_cart_settings && shopping_cart.shopping_cart_settings.add_to_cart_without_login){
			if(frappe.session.user === "Guest"){
				shopping_cart.update_ui_from_local_cart()
			} else {
				let local_cart = JSON.parse(localStorage.getItem("local_cart") || "{}")
				if(local_cart && Object.keys(local_cart).length){
					frappe.call({
						method: "erpnext.shopping_cart.cart.set_quotation_local_cart",
						args: {
							local_cart: localStorage.getItem("local_cart")
						}
					}).then(r => {
						if(r && r.message){
							localStorage.setItem("local_cart", JSON.stringify(r.message))
							shopping_cart.update_ui_from_local_cart()
						}
					}).always(r => {
						setTimeout(() => {
							localStorage.setItem("local_cart", '')
						}, 2000)
					})
				}
			}
		}
	});
});

$.extend(shopping_cart, {
	show_shoppingcart_dropdown: function() {
		$(".shopping-cart").on('shown.bs.dropdown', function() {
			if (!$('.shopping-cart-menu .cart-container').length) {
				let local_cart = null
				if(frappe.session.user === "Guest" && shopping_cart.shopping_cart_settings.add_to_cart_without_login && localStorage.getItem("local_cart")){
					local_cart = localStorage.getItem("local_cart")
				}
				return frappe.call({
					method: 'erpnext.shopping_cart.cart.get_shopping_cart_menu',
					args: {context: local_cart},
					callback: function(r) {
						if (r.message) {
							$('.shopping-cart-menu').html(r.message);
						}
					}
				});
			}
		});
	},

	get_cart_settings: function(callback=null){
		frappe.call({
			method: "erpnext.shopping_cart.doctype.shopping_cart_settings.shopping_cart_settings.get_shopping_cart_settings_doc"
		}).then(r => {
			shopping_cart.shopping_cart_settings = (r && r.message) ? r.message : {}
			callback && callback()
		})
	},

	rotateElement: function($element, angle, duration) {
		$element.animate({ deg: angle }, {
			duration: duration,
			step: function(now) {
				$(this).css({
					transform: 'rotate(' + now + 'deg)'
				});
			}
		});
	},

	update_cart: function(opts) {
		shopping_cart.rotateElement($('.fa-cart-plus'), 30, 500)
		shopping_cart.rotateElement($('.fa-cart-plus'), -30, 500)
		shopping_cart.rotateElement($('.fa-cart-plus'), 0, 500)
		if(frappe.session.user==="Guest"){
			if(localStorage && shopping_cart.shopping_cart_settings.add_to_cart_without_login){
				return this.update_local_cart(opts)
			} else {
				if(localStorage) localStorage.setItem("last_visited", window.location.pathname);
				window.location.href = "/login#customer_login";
			}
		} else {
			return frappe.call({
				type: "POST",
				method: "erpnext.shopping_cart.cart.update_cart",
				args: {
					item_code: opts.item_code,
					qty: opts.qty,
					additional_notes: opts.additional_notes
				},
				btn: opts.btn,
				callback: function(r) {
					shopping_cart.set_cart_count();
					if (r.message.shopping_cart_menu) {
						$('.shopping-cart-menu').html(r.message.shopping_cart_menu);
					}
					if(opts.callback)
						opts.callback(r);
				}
			});
		}
	},

	update_local_cart: function(opts){
		return frappe.call({
			method: "erpnext.shopping_cart.cart.update_local_cart",
			args: {
				opts: JSON.stringify(opts), 
				local_cart: localStorage.getItem("local_cart")
			}
		}).then(r => {
			if(r.exc) return
			localStorage.setItem("local_cart", JSON.stringify(r.message))
			if(opts.callback) opts.callback(r);
			shopping_cart.update_ui_from_local_cart();
		})
	},

	update_ui_from_local_cart: function(){
		const local_cart = JSON.parse(localStorage.getItem("local_cart") || "{}") || {}
		if(!(local_cart && Object.keys(local_cart).length && local_cart.doc)) return
		for(let item of (local_cart.doc.items || [])){
			if(item.item_code && item.qty){
				let $btn = $(`.btn.item-add-to-cart-btn[data-item-code="${typeof CSS == 'object' ? CSS.escape(item.item_code) : item.item_code}"]`)
				$btn.addClass("d-none");
				$btn.siblings(".input-group").removeClass("d-none")
				$btn.siblings(".input-group").find(".input-number").val(item.qty)
			}
		}
		shopping_cart.set_cart_count();
	},

	set_cart_count: function() {
		var cart_count = frappe.get_cookie("cart_count");
		if(frappe.session.user==="Guest") {
			cart_count = 0;
			let local_doc = JSON.parse(localStorage.getItem("local_cart") || "{}").doc
			if(local_doc && local_doc.items && shopping_cart.shopping_cart_settings.add_to_cart_without_login){
				cart_count = local_doc.items.length || 0
			}
		}

		if(cart_count) {
			$(".shopping-cart").toggleClass('hidden', false);
		}

		var $cart = $('.cart-icon');
		var $cart_small = $('.cart-icon-small');
		var $badge = $cart.find(".cart-count");

		if(parseInt(cart_count) === 0 || cart_count === undefined) {
			$cart.css("display", "none");
			$(".cart-items").html('Cart is Empty');
			$(".cart-tax-items").hide();
			$(".btn-place-order").hide();
			$(".cart-addresses").hide();
		}
		else {
			$cart.css("display", "inline");
		}

		if(cart_count) {
			$badge.html(cart_count);
			$badge.show();
		} else {
			// $badge.remove();
			$badge.hide();
		}
		if(window.innerWidth >= 992){
			$cart_small.css("display", "none");
		}
	},

	shopping_cart_update: function({item_code, qty, cart_dropdown, additional_notes}, fn) {
		frappe.freeze();
		shopping_cart.update_cart({
			item_code,
			qty,
			additional_notes,
			btn: this,
			callback: function(r) {
				frappe.unfreeze();
				if(!r.exc) {
					$(".cart-items").html(r.message.items);
					$(".cart-tax-items").html(r.message.taxes);
					if (cart_dropdown != true) {
						// $(".cart-icon").hide();
					}
					if(fn) {
						fn(r.message);
					}
				}
			},
		});
	},


	bind_dropdown_cart_buttons: function () {
		$(".cart-icon").on('click', '.number-spinner button', function () {
			var btn = $(this),
				input = btn.closest('.number-spinner').find('input'),
				oldValue = input.val().trim(),
				newVal = 0;

			if (btn.attr('data-dir') == 'up') {
				newVal = parseInt(oldValue) + 1;
			} else {
				if (oldValue > 1) {
					newVal = parseInt(oldValue) - 1;
				}
			}
			input.val(newVal);
			var item_code = input.attr("data-item-code");
			shopping_cart.shopping_cart_update({item_code, qty: newVal, cart_dropdown: true});
			return false;
		});

	},

	show_cart_navbar: function () {
		$(".shopping-cart").toggleClass('hidden', shopping_cart.shopping_cart_settings.enabled ? false : true);
	}
});
